import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { TechnicalCriteriaType } from '@1po/1po-bff-fe-spec/generated/catalog/vehicle/model/TechnicalCriteriaType';
import { setTechnicalCriteriaPdfType } from 'domains/catalog/Catalog.store';
import { TechnicalInfoLocal } from 'domains/catalog/Catalog.types';
import { TechnicalCriteriaContent } from 'pages/CatalogPage/common/TechnicalCriteria/TechnicalCriteriaContent';
import { TechnicalCriteriaMenu } from 'pages/CatalogPage/common/TechnicalCriteria/TechnicalCriteriaMenu';
import { Flex, IconType, MarginBox } from 'UI';

export interface ItemElement {
  label: string;
  icon: IconType;
  type: TechnicalCriteriaType;
  data: TechnicalInfoLocal[] | undefined;
}

export interface TechnicalCriteriaMenuAndContentI {
  items: ItemElement[];
  refreshCategories?: () => void;
}

export function TechnicalCriteriaMenuAndContent({ items, refreshCategories }: TechnicalCriteriaMenuAndContentI) {
  const [currentSelected, setCurrentSelected] = useState<TechnicalCriteriaType>();
  const dispatch = useDispatch();
  const item = items.find((itemElement) => itemElement.type === currentSelected);
  const enableReset = items
    .map((itemElement) => itemElement.data)
    .flat()
    .some((x) => !x?.enabled);

  const handleSetCurrentSelected = (type: TechnicalCriteriaType) => {
    setCurrentSelected(type);
    dispatch(setTechnicalCriteriaPdfType(type));
  };

  useEffect(() => {
    if (items.length > 0 && !currentSelected) {
      handleSetCurrentSelected(items[0].type);
    }
    // eslint-disable-next-line
  }, [items, currentSelected]);

  if (item === undefined) {
    return null;
  }

  return (
    <Flex>
      <TechnicalCriteriaMenu items={items} setCurrentSelected={handleSetCurrentSelected} active={item.type} />
      <MarginBox ml={45} />
      <TechnicalCriteriaContent item={item} refreshCategories={refreshCategories} enableReset={enableReset} />
    </Flex>
  );
}
